import React from 'react';

interface SheetFieldProps {
  /** Field name — becomes the placeholder (the label lives inside the empty
   *  field per the design language) AND the aria-label (mandatory: the
   *  placeholder disappears on entry). */
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  name?: string;
  autoComplete?: string;
  error?: string | null;
  disabled?: boolean;
  autoFocus?: boolean;
}

const SheetField: React.FC<SheetFieldProps> = ({
  label,
  value,
  onChange,
  type = 'text',
  name,
  autoComplete,
  error,
  disabled,
  autoFocus,
}) => (
  <div className="tend-field">
    <input
      className={`tend-input${error ? ' tend-input--error' : ''}`}
      type={type}
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={label}
      aria-label={label}
      autoComplete={autoComplete}
      disabled={disabled}
      autoFocus={autoFocus}
    />
    {error && <div className="tend-field-error">{error}</div>}
  </div>
);

export default SheetField;
